import 'angular:locale/data:de-AT';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "de-AT";
